import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CashFlow2PageUI from './CashFlow2PageUI.js'

class CashFlow2PageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      yearMonthList: null,
      subTotalList: null,
      createMode: false,
      updateMode: false,
      selectedCashFlow: null
    }
  }

  render() {
    return (
      <CashFlow2PageUI
        context={this.props.context}
        account={this.state.account}
        bankAccountList={this.state.bankAccountList}
        loanBankAccountNum={this.state.loanBankAccountNum}
        genBankAccountNum={this.state.genBankAccountNum}
        bankAccountMonthList={this.state.bankAccountMonthList}
        subTotalList={this.state.subTotalList}
        yearMonthList={this.state.yearMonthList}
        onRefreshClick={this.onRefreshClick}
        //
        createMode={this.state.createMode}
        onCreateClick={() => { this.setState({ 'createMode': true }) }}
        onCancelClick={() => { this.setState({ 'createMode': false, 'updateMode': false }) }}
        //
        onUpdateClick={this.onUpdateClick}
        updateMode={this.state.updateMode}
        selectedCashFlow={this.state.selectedCashFlow}
        bankAccountNumber={this.props.match.params.bankAccountId || this.state.bankAccountList && this.state.bankAccountList[0].bankAccountNumber}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getBankAccounts(context)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.bankAccountId == this.props.match.params.bankAccountId)
      return

    let context = this.props.context
    this.getBankAccounts(context)
  }

  getBankAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/bankAccounts`,
      cacheKey: CacheKeys.BankAccounts2(this.props.match.params.accountId),
      callback: this.getBankAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBankAccountsCallback = (response) => {
    this.setState(
      {
        bankAccountList: response.bankAccountList,
        errorList: response.errorList
      }, () => {
        let bankAccountNumber = this.props.match.params.bankAccountId || response.bankAccountList[0].bankAccountNumber
        this.getMonthlyCashFlow(this.props.context, bankAccountNumber)
      }
    )

    let loanAcc = response.bankAccountList.filter(ba => ba.purpose === 'loan')
    let genAcc = response.bankAccountList.filter(ba => ba.purpose === 'general')
    if (loanAcc.length > 0 && genAcc.length > 0) {
      this.setState({
        loanBankAccountNum: loanAcc[0].bankAccountNumber,
        genBankAccountNum: genAcc[0].bankAccountNumber
      })
    }
    else if (genAcc.length > 0) {
      this.setState({
        genBankAccountNum: genAcc[0].bankAccountNumber,
      })
    }
  }

  getMonthlyCashFlow(context, bankAccountNumber) {
    let cacheManager = new CacheManager({
      resource: `/api/su/bankAccounts/${bankAccountNumber}/months/cashFlows`,
      cacheKey: CacheKeys.MonthlyCashFlow(bankAccountNumber),
      callback: this.getMonthlyCashFlowCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getMonthlyCashFlowCallback = (response) => {
    this.setState({ subTotalList: response.subTotalList, yearMonthList: response.yearMonthList })
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.MonthlyCashFlow(this.props.match.params.bankAccountId))
    CacheManager.removeObject(CacheKeys.BankAccounts2(this.props.match.params.accountId))

    this.setState({
      bankAccountList: null,
      subTotalList: null,
      yearMonthList: null
    }, () => {
      this.getBankAccounts(context)
    })
  }
}

export default withRouter(CashFlow2PageSF)
